import parseHtml from "@utils/parseHtml";
import { $, parent } from "@utils/select";
import { listen } from "@utils/bph";
import Alpine from "alpinejs";
import gsap, { ScrollToPlugin } from "gsap/all";

gsap.registerPlugin(ScrollToPlugin);

export default (data) => ({
  ...data,
  loading: false,
  filtersOpen: false,
  currentFilter: "",
  isMobile: false,

  init() {
    this.sortBy = window.addEventListener("popstate", (event) => {
      this.render(event?.state?.params, false);
    });

    listen("lg", ({ matches }) => {
      this.currentFilter = "";
      this.isMobile = !matches;
      this.toggleFilters(false);
    });
  },

  toggleFilters(state) {
    let open = state;
    if (open) open = "!z-30";
    this.filtersOpen = state;
    Alpine.store("global").blockScroll(state);
    Alpine.store("global").showCover(open);
  },

  closeAll() {
    this.currentFilter = "";
    this.toggleFilters(false);
  },

  goToLink() {
    this.render(this.$el.href.split("?")[1]);
    const $parent = $(`#shopify-section-${this.sectionId}`);
    const { top } = $parent.getBoundingClientRect();

    if (top >= window.scrollY) return;
    gsap.to(window, { scrollTo: $parent, duration: 0.2 });
  },

  toggleFilter(id) {
    this.currentFilter = this.currentFilter === id ? "" : id;
  },

  onChange() {
    const form =
      this.$el.nodeName === "FORM" ? this.$el : parent(this.$el, "form");

    const formData = new FormData(form);
    const params = new URLSearchParams(formData).toString();
    this.render(params);
  },

  updateHash(params) {
    if (params) {
      history.pushState(
        { params },
        null,
        `${window.location.pathname}${params && `?${params}`}`
      );
    } else {
      history.pushState({}, null, window.location.pathname);
    }
  },

  async render(params, updateHash = true) {
    if (this.loading) return;
    this.loading = true;

    const p = params ? `&${params}` : "";
    const url = `${window.location.pathname}?section_id=${this.sectionId}${p}`;
    const response = await fetch(url);

    if (response.status !== 200) {
      console.error(response.statusText);
      this.loading = false;
      return;
    }

    const text = await response.text();
    const $dom = parseHtml(text);

    this.$refs.container.parentNode.replaceChild(
      $('[x-ref="container"]', $dom),
      this.$refs.container
    );
    if (updateHash) this.updateHash(params);
    this.loading = false;
    // gsap.to(window, { scrollTo: this.$root, duration: 0.2 });
  },
});
